/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import Header from './Header';
import { moduleName } from '../utils/Manager';

export function DocPage({ children }){

    const Items = ({ type, maxSize }) => Object.keys(window.pages.docs[moduleName][type]).sort().map(x => <a href={`/${moduleName}/${type}/${x}`} className="small">{x.slice(0, maxSize)}</a>);

    React.useEffect(() => {
        if(window.innerWidth > 700) document.querySelector('.docspace').classList.add('open');
        const maximumHeight = document.querySelector('.content').scrollHeight + 40;
        const minimumHeight = document.querySelector('.sidebar').scrollHeight;
        document.querySelector('.sidebar').style.height = (minimumHeight > maximumHeight ? minimumHeight : maximumHeight) + 'px';
    }, []);

    return <>
        <Header/>

        <div className="docspace">
            <div className="sidebar">
                <div id="main-sidebar">
                    <a href={`/${moduleName}`} className="large">GENERAL</a>
                    <a href={`/${moduleName}`} className="small">Welcome</a>
                    <a href={`/${moduleName}/search`} className="small">Search</a>

                    <a href="javascript:void(0)" className="large">MODULES</a>
                    <a href="/main" className="small">Main</a>
                    <a href="/apiTypes" className="small">API Types</a>

                    <a href="javascript:void(0)" className="large">FUNCTIONS</a>
                    <Items type="function"/>

                    <a href="javascript:void(0)" className="large">CONSTANTS</a>
                    <Items type="constant"/>

                    <a href="javascript:void(0)" className="large">ENUMS</a>
                    <Items type="enum"/>

                    <a href="javascript:void(0)" className="large">CLASSES</a>
                    <Items type="class"/>

                    <a href="javascript:void(0)" className="large">INTERFACES</a>
                    <Items type="interface"/>

                    <a href="javascript:void(0)" className="large">TYPE ALIASES</a>
                    <Items type="typeAlias" maxSize={22}/>
                </div>
            </div>
            <div className="content">{children}</div>
        </div>

        <a onClick={() => {
            document.querySelector('.docspace').classList.toggle('open');
        }} className="nav"><i className="fa fa-bars fa-2x"/></a>
    </>

}